export const isUserAuthorized = (role, rights, right) => {
  if ((role === "ADMIN" && rights && rights.split(',').some(elem => elem === right)) || (role === "USER" && (right === 'exp' || right === 'designs'))) {
    return true
  }
  return false;
}
